import {FBFieldWithPriceBaseOptions} from "FormBuilder/Fields/Core/FBFieldWithPriceBase.Options";
import {FieldTypeEnum} from "FormBuilder/Fields/Core/FBFieldBase.options";
import {StoreDataType} from "shared/core/Store/StoreBase";
import {IconOrImage} from "FormBuilder/Fields/Core/Interfaces/IconOrImage";


export class FBDatePickerOptions extends FBFieldWithPriceBaseOptions{
    public DefaultDate:string;
    public Placeholder:string;

    public ShowQuantitySelector:boolean;
    public Format:string;
    public WeekStartOn: number;
    @StoreDataType(Object)
    public Icon:IconOrImage;
    public EnableTimePicker:boolean;
    public TimeFormat:string;

    protected LoadDefaultValues() {
        super.LoadDefaultValues();
        this.Type=FieldTypeEnum.Datepicker;
        this.Label='Datepicker';
        this.DefaultDate='';
        this.Placeholder='';
        this.Format='dd/MM/yyyy';
        this.TimeFormat='h:mm';
        this.WeekStartOn=0;
        this.EnableTimePicker=false;
        this.Icon={ImageType:'none',Ref:null};

    }
}
